import axios from 'axios';

const list = (params) => axios.get('comprador/page', { params });

export default {
  list,
};
